"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyReducer = exports.initialState = void 0;
const types_1 = require("./types");
exports.initialState = {};
const reducer = (state = exports.initialState, action) => {
    switch (action.type) {
        case types_1.SurveyActionTypes.SET_INTERVIEW:
            return Object.assign(Object.assign({}, state), { interview: action.interview, interviewLoaded: action.interviewLoaded, 
                // Reset navigation and other states for this newly set interview, to not clash with previous interviews
                navigation: undefined, errors: undefined, submitted: undefined, reviewDecisions: undefined });
        case types_1.SurveyActionTypes.UPDATE_INTERVIEW:
            return Object.assign(Object.assign({}, state), { interview: action.interview, interviewLoaded: action.interviewLoaded, errors: action.errors, submitted: action.submitted });
        case types_1.SurveyActionTypes.ADD_CONSENT:
            return Object.assign(Object.assign({}, state), { hasConsent: action.consented });
        case types_1.SurveyActionTypes.NAVIGATE: {
            const { targetSection } = action;
            return Object.assign(Object.assign({}, state), { navigation: {
                    currentSection: targetSection,
                    navigationHistory: state.navigation
                        ? [...state.navigation.navigationHistory, state.navigation.currentSection]
                        : []
                } });
        }
        case types_1.SurveyActionTypes.SET_REVIEW_DECISIONS:
            return Object.assign(Object.assign({}, state), { reviewDecisions: action.reviewDecisions });
        case types_1.SurveyActionTypes.INIT_NAVIGATE: {
            const { navigationService } = action;
            return Object.assign(Object.assign({}, state), { navigationService: navigationService });
        }
        default:
            return state;
    }
};
exports.surveyReducer = reducer;
//# sourceMappingURL=reducer.js.map